import type { Routes } from '@angular/router';
import { authGuard, guestGuard } from '@soft2code/nexpo-lib/core';
import { activeEventGuard } from './core/workspace/active-event.guard';

/**
 * Entrar e escolher a feira ficam **fora** da moldura: quem ainda não escolheu
 * a edição não pode ver um cabeçalho que promete uma.
 *
 * Fora do v1, preservado na branch `parking/admin-v2`: financeiro, relatórios,
 * push, integrações, auditoria e papéis. A configuração da feira e o desenho da
 * planta são editados no console da plataforma e pedidos aqui por chamado.
 */
export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'now' },
	{
		path: 'sign-in',
		canActivate: [guestGuard],
		loadComponent: () => import('./features/account/sign-in-page/sign-in-page').then((m) => m.SignInPage),
	},
	{
		path: 'fairs',
		canActivate: [authGuard],
		loadComponent: () => import('./features/account/fairs-page/fairs-page').then((m) => m.FairsPage),
	},
	{
		path: '',
		canActivate: [authGuard, activeEventGuard],
		loadComponent: () => import('./layout/admin-shell/admin-shell').then((m) => m.AdminShell),
		children: [
			{ path: 'now', loadComponent: () => import('./features/now/now-page/now-page').then((m) => m.NowPage) },
			{ path: 'fair', loadComponent: () => import('./features/fair/fair-page/fair-page').then((m) => m.FairPage) },
			{
				path: 'exhibitors',
				loadComponent: () =>
					import('./features/exhibitors/exhibitors-page/exhibitors-page').then((m) => m.ExhibitorsPage),
			},
			{
				path: 'floor-plan',
				loadComponent: () =>
					import('./features/floor-plan/floor-plan-page/floor-plan-page').then((m) => m.FloorPlanPage),
			},
			{ path: 'agenda', loadChildren: () => import('./features/agenda/agenda.routes').then((m) => m.AGENDA_ROUTES) },
			{
				path: 'content',
				loadChildren: () => import('./features/content/content.routes').then((m) => m.CONTENT_ROUTES),
			},
			{ path: 'staff', loadComponent: () => import('./features/staff/staff-page/staff-page').then((m) => m.StaffPage) },
			{
				path: 'support',
				loadComponent: () => import('./features/support/support-page/support-page').then((m) => m.SupportPage),
			},
			{
				path: 'profile',
				loadComponent: () => import('./features/profile/profile-page/profile-page').then((m) => m.ProfilePage),
			},
		],
	},
	{ path: '**', redirectTo: 'now' },
];
